// @flow
import React from 'react';
import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CircleIcon from '@material-ui/icons/PanoramaFishEye';
import RectangleIcon from '@material-ui/icons/Crop75';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Box from "@material-ui/core/Box";
import type { Props as AlertProps } from './Alert';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        position: 'relative'
    },
    icon: {
        display: 'block'
    },
    value: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    color_red: {
        position: 'relative',
        color: theme.palette.error.main
    }
}));

export type Props = $ReadOnly<{
    alert: $PropertyType<AlertProps, 'alert'>
}>;

function AlertIcon({ alert }: Props) {
    const classes = useStyles();

    if(alert.type === 'speeding') {
        return (
            <div className={classnames(classes.root, classes.color_red)}>
                <CircleIcon fontSize="large" className={classes.icon} />
                <Box display="flex" className={classes.value}>
                    {alert.meta && alert.meta.speedLimit}
                </Box>
            </div>
        );
    } else if(alert.type === 'zoneConflict') {
        return (
            <div className={classnames(classes.root, classes.color_red)}>
                <RectangleIcon fontSize="large"/>
            </div>
        );
    } else {
        return (
            <div className={classnames(classes.root, classes.color_red)}>
                <HelpOutlineIcon fontSize="large"/>
            </div>
        );
    }

    return null;
}

export default AlertIcon;